import React from "react";
import { t } from "@auto/services";

import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

import { getNumericField, labelOf } from "../model";
import { canOpenGeographyContext } from "@src/security/permissions";

import Card from "../primitives/Card";
import EmptyState from "../primitives/EmptyState";

import styles from "../../ElectoralGeographyPage.module.styl";

const VotingCentersPanel = ({ gui, state, events }) => {
  const selectedSection = state.selection.section;
  const selectedVotingCenter = state.selection.votingCenter;

  if (!selectedSection) {
    return null;
  }

  return (
    <Card
      icon={PlaceOutlinedIcon}
      title={t("geo.votingCentersSelectedSection")}
      subtitle={labelOf(selectedSection)}
    >
      {state.data.votingCenters.length ? (
        <div className={styles.centerList}>
          {state.data.votingCenters.map((votingCenter) => {
            const capacity = getNumericField(votingCenter, "capacity", "capacity");
            const disabled = Number(votingCenter?.status) === 2;

            return (
              <button
                type="button"
                key={votingCenter.gid}
                className={`${styles.centerItem} ${
                  selectedVotingCenter?.gid === votingCenter.gid
                    ? styles.selectedCenterItem
                    : ""
                } ${disabled ? styles.disabledCenterItem : ""}`}
                onClick={() => events.votingCenterSelected.publish(votingCenter)}
                onContextMenu={canOpenGeographyContext(gui, "voting-center") ? (event) => {
                  event.preventDefault();
                  events.contextMenuOpened.publish({
                    event,
                    type: "voting-center",
                    item: votingCenter,
                  });
                } : undefined}
              >
                <strong>{labelOf(votingCenter)}</strong>

                {capacity !== "" ? (
                  <span>{t("geo.capacity")}: {capacity}</span>
                ) : null}

                {votingCenter.address ? (
                  <span>{votingCenter.address}</span>
                ) : null}
              </button>
            );
          })}
        </div>
      ) : (
        <EmptyState>{t("geo.noVotingCentersSection")}</EmptyState>
      )}
    </Card>
  );
};

export default VotingCentersPanel;